import { Route } from '@angular/router';

import { ActivityTrackerPage } from './pages/activity-tracker/activity-tracker.page';
import { AiHubFsePlusPage } from './pages/ai-hub-fse-plus/ai-hub-fse-plus.page';
import { AiHubSlePlusPage } from './pages/ai-hub-sle-plus/ai-hub-sle-plus.page';
import { AiHubPage } from './pages/ai-hub/ai-hub.page';
import { CasesPage } from './pages/cases/cases.page';
import { FamilyTreePage } from './pages/family-tree/family-tree.page';
import { InsightsPage } from './pages/insights/insights.page';
import { InsurancePage } from './pages/insurance/insurance.page';
import { InvestmentsPage } from './pages/investments/investments.page';
import { OpportunitiesPage } from './pages/opportunities/opportunities.page';
import { BiAnalysisPage } from './pages/bi-analysis/bi-analysis.page';
import { ClientServicePage } from './pages/client-service/client-service.page';
import { RouteListPage } from './pages/route-list/route-list.page';
import { SalesIntelligencePage } from './pages/sales-intelligence/sales-intelligence.page';
import { TargetsPage } from './pages/targets/targets.page';
import { WorkflowFsePlusPage } from './pages/workflow-fse-plus/workflow-fse-plus.page';
import { WorkflowSlePlusPage } from './pages/workflow-sle-plus/workflow-sle-plus.page';
import { WorkflowPage } from './pages/workflow/workflow.page';

export const appRoutes: Route[] = [
  { path: '', component: RouteListPage },
  { path: 'activity-tracker', component: ActivityTrackerPage },
  { path: 'targets', component: TargetsPage },
  { path: 'insights', component: InsightsPage },
  { path: 'sales-intelligence', component: SalesIntelligencePage },
  { path: 'ai-hub', component: AiHubPage },
  { path: 'ai-hub-fse-plus', component: AiHubFsePlusPage },
  { path: 'ai-hub-sle-plus', component: AiHubSlePlusPage },
  { path: 'workflow', component: WorkflowPage },
  { path: 'workflow-fse-plus', component: WorkflowFsePlusPage },
  { path: 'workflow-sle-plus', component: WorkflowSlePlusPage },
  { path: 'insurance', component: InsurancePage },
  { path: 'investments', component: InvestmentsPage },
  { path: 'opportunities', component: OpportunitiesPage },
  { path: 'cases', component: CasesPage },
  { path: 'client-service', component: ClientServicePage },
  { path: 'bi-analysis', component: BiAnalysisPage },
  { path: 'family-tree', component: FamilyTreePage },
  { path: '**', redirectTo: '' },
];
